import { api } from './apiClient';

/** Current agreement version — bump when text changes to require re-acceptance. */
export const IP_PROTECTION_AGREEMENT_VERSION = '7.0';

/** @deprecated Use IP_PROTECTION_AGREEMENT_VERSION */
export const IP_NOTICE_VERSION = IP_PROTECTION_AGREEMENT_VERSION;

export type UserLegalData = {
  onboarded?: boolean;
  affidavitAcceptedAt?: string;
  affidavitVersion?: string;
  affidavitAcceptedIp?: string;
  termsAcceptedAt?: string;
  termsVersion?: string;
  profileData?: { fullName?: string };
  displayName?: string | null;
};

export function hasAcceptedIpProtectionAgreement(
  userData: UserLegalData | null | undefined,
): boolean {
  if (!userData?.onboarded) return false;
  if (!userData.affidavitAcceptedAt) return false;
  return userData.affidavitVersion === IP_PROTECTION_AGREEMENT_VERSION;
}

/** @deprecated Use hasAcceptedIpProtectionAgreement */
export const hasAcceptedIntellectualPropertyNotice = hasAcceptedIpProtectionAgreement;

export function resolvePostAuthPath(userData: UserLegalData | null | undefined): string {
  if (!userData?.onboarded) return '/onboarding';
  if (!hasAcceptedIpProtectionAgreement(userData)) return '/ip-protection-agreement';
  return '/dashboard';
}

export type ClientMetadata = {
  timezone?: string;
  language?: string;
  platform?: string;
  screenResolution?: string;
};

export function collectClientMetadata(): ClientMetadata {
  return {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    language: navigator.language,
    platform: navigator.userAgent.slice(0, 256),
    screenResolution: `${window.screen.width}x${window.screen.height}`,
  };
}

export async function acceptIpProtectionAgreement(): Promise<{
  status: string;
  version?: string;
  recordId?: string;
}> {
  return api.post('/api/legal/ip-protection-agreement/accept', {
    clientMetadata: collectClientMetadata(),
  });
}

/** @deprecated Use acceptIpProtectionAgreement */
export const acceptIntellectualPropertyNotice = acceptIpProtectionAgreement;
